import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {CmsCalendarHdrContainerModel } from '../../../../../../models/aggregates/cms/event-calendar';

@Injectable({providedIn: 'root'})

export class CmsCalendarHdrService extends BaseApiTemplateService<CmsCalendarHdrContainerModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-hdrs/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-hdrs/backoffice-ep';
        this.httpClient = http;
      }
}